module.exports = __webpack_public_path__ + "static/media/4.1bd7878c.jpg";